export default "__VITE_ASSET__9034687f__"